import { motion, useReducedMotion } from "framer-motion";
import { CRITICAL_PATH_NODES } from "../data";

// Signature motif: a schedule-style "critical path" that draws itself in on load,
// connecting labelled programme milestones. Nodes fade in as the line reaches them.
export const CriticalPath = () => {
  const reduce = useReducedMotion();

  // Node coordinates on a 1000 x 320 canvas (stepped, schedule-like).
  const pts = [
    { x: 70, y: 250 },
    { x: 285, y: 175 },
    { x: 500, y: 220 },
    { x: 715, y: 120 },
    { x: 930, y: 60 },
  ];
  const d = `M ${pts[0].x} ${pts[0].y} L ${pts[1].x} ${pts[1].y} L ${pts[2].x} ${pts[2].y} L ${pts[3].x} ${pts[3].y} L ${pts[4].x} ${pts[4].y}`;

  const draw = {
    hidden: { pathLength: 0, opacity: 0 },
    show: {
      pathLength: 1,
      opacity: 1,
      transition: { pathLength: { duration: reduce ? 0 : 2.4, ease: [0.4, 0, 0.2, 1] }, opacity: { duration: 0.2 } },
    },
  };

  return (
    <div data-testid="critical-path-diagram" className="w-full">
      <svg viewBox="0 0 1000 320" className="w-full h-auto overflow-visible" role="img" aria-label="Critical path programme timeline">
        {/* faint grid baseline */}
        {[80, 160, 240].map((y) => (
          <line key={y} x1="0" y1={y} x2="1000" y2={y} stroke="#101820" strokeOpacity="0.06" strokeWidth="1" />
        ))}

        {/* the critical path line */}
        <motion.path
          d={d}
          fill="none"
          stroke="#C08A3E"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          variants={draw}
          initial="hidden"
          animate="show"
        />

        {/* nodes + labels */}
        {pts.map((p, i) => {
          const delay = reduce ? 0 : 0.35 + i * (2.4 / pts.length);
          const isRisk = i === 2; // 'Delay Flagged' node highlighted differently
          return (
            <motion.g
              key={i}
              initial={{ opacity: 0, scale: 0.4 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay, duration: 0.4, ease: "backOut" }}
            >
              <circle cx={p.x} cy={p.y} r="16" fill="#F6F3EC" stroke={isRisk ? "#C08A3E" : "#3E6259"} strokeWidth="2.5" />
              <circle cx={p.x} cy={p.y} r="5" fill={isRisk ? "#C08A3E" : "#3E6259"} />
              <text
                x={p.x}
                y={p.y - 30}
                textAnchor="middle"
                className="font-mono"
                fill="#101820"
                fontSize="15"
                fontWeight="500"
              >
                {CRITICAL_PATH_NODES[i]}
              </text>
              <text x={p.x} y={p.y + 40} textAnchor="middle" className="font-mono" fill="#5B6472" fontSize="11">
                {`0${i + 1}`}
              </text>
            </motion.g>
          );
        })}
      </svg>
    </div>
  );
};
